import {useContext} from 'react';
import SkuQuotaMastersContext from './sku-quota-masters-context';

const useSkuQuotaMasters = () => {
  const context = useContext(SkuQuotaMastersContext);
  return context
};

export default useSkuQuotaMasters;
